import { render, staticRenderFns } from "./FormClasses.vue?vue&type=template&id=19224de3&"
import script from "./FormClasses.vue?vue&type=script&lang=js&"
export * from "./FormClasses.vue?vue&type=script&lang=js&"
import style0 from "./FormClasses.vue?vue&type=style&index=0&id=19224de3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports